/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import Divider from '@mui/material/Divider';
import LoadingButton from '@mui/lab/LoadingButton';
import AddIcon from '@mui/icons-material/Add';
import {
  mainContainer,
  titleStyle,
  titleHighlightedStyle,
  subtitleStyle,
  containerButton,
  loadingButtonDisabledStyle,
  loadingButtonStyle,
  exportIcon,
} from './style';

function Title({
  title = '',
  titleHighlighted = '',
  subtitle = '',
  centerText = false,
  textButton = null,
  disabledButton = true,
  eventButton = async () => {},
  ExportToExcel = null,
}) {
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    setLoading(true);
    await eventButton();
    setLoading(false);
  };
  const width = centerText ? '100%' : '75%';
  const textAlign = centerText ? 'center' : 'left';
  const styleText = { width, textAlign };

  return (
    <div style={mainContainer}>
      <div style={{ display: 'flex' }}>
        <div style={styleText}>
          <h1 style={titleStyle}>
            {title}
            <span style={titleHighlightedStyle}> {titleHighlighted}</span>
          </h1>
          <p style={subtitleStyle}>{subtitle}</p>
        </div>

        {textButton ? (
          <div style={containerButton}>
            <LoadingButton
              onClick={handleClick}
              loading={loading}
              loadingPosition="start"
              startIcon={<AddIcon />}
              variant="contained"
              disabled={disabledButton}
              style={disabledButton ? loadingButtonDisabledStyle : loadingButtonStyle}
            >
              {textButton}
            </LoadingButton>
          </div>
        ) : null}
        {ExportToExcel ? <div style={exportIcon}>{ExportToExcel}</div> : null}
      </div>
      <Divider variant="large" style={{ marginBottom: '2rem' }} />
    </div>
  );
}

export default Title;
